import { PlusIcon } from "@phosphor-icons/react";
import { LinkButton } from "@/components/ui/button";
import { InlineSearchField } from "@/components/ui/controls/searchfield";
import { ScheduledBriefingsTabPageHeader } from "@/routes/scheduled-briefings/ScheduledBriefingsTabPageHeader";

export const BRIEFING_CREATE_PATH = "/scheduled-briefings/create";

const NewBriefingLink = () => (
  <LinkButton
    to={BRIEFING_CREATE_PATH}
    variant="default"
    size="sm"
    className="h-8 gap-2"
  >
    <PlusIcon aria-hidden className="size-4" />
    New briefing
  </LinkButton>
);

interface BriefingsIndexHeaderProps {
  briefingCount: number;
  description: string;
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
}

const BriefingsIndexHeader = ({
  briefingCount,
  description,
  searchTerm,
  onSearchTermChange,
}: BriefingsIndexHeaderProps) => (
  <ScheduledBriefingsTabPageHeader
    title="Briefings"
    description={description}
    actions={
      <div className="flex w-full flex-col items-stretch gap-3 sm:w-auto sm:items-end">
        <NewBriefingLink />
        {briefingCount > 1 || searchTerm.length > 0 ? (
          <InlineSearchField
            ariaLabel="Search briefings"
            clearAriaLabel="Clear briefing search"
            value={searchTerm}
            onValueChange={onSearchTermChange}
          />
        ) : null}
      </div>
    }
  />
);

export default BriefingsIndexHeader;
